// extracted by mini-css-extract-plugin
export var captcha = "CandidatureForm-module--captcha--a5fe5";
export var closeButton = "CandidatureForm-module--closeButton--99b3c";
export var dragerror = "CandidatureForm-module--dragerror--658b1";
export var errormeesage = "CandidatureForm-module--errormeesage--a358d";
export var filesCard = "CandidatureForm-module--filesCard--50f17";
export var fileslist = "CandidatureForm-module--fileslist--e67f7";
export var icon = "CandidatureForm-module--icon--58b5d";
export var removeFileBtn = "CandidatureForm-module--removeFileBtn--c2ef2";
export var selectFiles = "CandidatureForm-module--selectFiles--2a8ee";
export var uploadedSelectFiles = "CandidatureForm-module--uploadedSelectFiles--a4409";
export var uploadedfile = "CandidatureForm-module--uploadedfile--207f4";
export var uploadedfileFinishBtn = "CandidatureForm-module--uploadedfileFinishBtn--9de8b";